import { render, staticRenderFns } from "./track-detail.vue?vue&type=template&id=53450d4f&scoped=true&"
import script from "./track-detail.vue?vue&type=script&lang=js&"
export * from "./track-detail.vue?vue&type=script&lang=js&"
import style0 from "./track-detail.vue?vue&type=style&index=0&id=53450d4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53450d4f",
  null
  
)

export default component.exports